import { Directive, OnInit, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[appBlurOnEscape], textarea[appBlurOnEscape]'
})
export class BlurOnEscapeDirective {
  @HostListener('keyup', ['$event'])
  keyup(event: KeyboardEvent) {
    this.handleKeyup(event);
  }

  constructor(
    private el: ElementRef
  ) { }

  handleKeyup(event: KeyboardEvent) {
    if (event.key.toLowerCase() === 'escape') {
      this.el.nativeElement.blur();
    }
  }
}
